export const TRANSFER_FREQUENCY = {
	oneTime: {
		frequency: 'ONCE',
		display: 'one-time',
		quantified: 1,
	},
	daily: {
		frequency: 'DAILY',
		display: 'daily',
		quantified: 260,
	},
	weekly: {
		frequency: 'WEEKLY',
		display: 'weekly',
		quantified: 52,
	},
	biWeekly: {
		frequency: 'BI-WEEKLY',
		display: 'biweekly',
		quantified: 26,
	},
	monthly: {
		frequency: 'MONTHLY',
		display: 'monthly',
		quantified: 12,
	},
};

export const PITHY_AUTO_STASH_FREQUENCY_TEXT = {
	ONCE: '',
	DAILY: 'daily',
	WEEKLY: 'weekly',
	'BI-WEEKLY': 'biweekly',
	MONTHLY: 'monthly',
};

export const SMART_SCHEDULE_MAPPINGS = {
	ONCE: 'oneTime',
	DAILY: 'daily',
	WEEKLY: 'weekly',
	'BI-WEEKLY': 'biWeekly',
	MONTHLY: 'monthly',
};

export const CLOSED_AASM_STATES = {
	closed: true,
};

export const RESTRICTED_REASON_CLOSED = 'CLOSED';

const MATCH_THE_MARKET_TICKER_UUID = {
	edge: '5b9051af-4306-44ac-b9f2-e195c401091f',
	staging: 'f15d0fdf-89b9-437c-8178-e830d44e28f3',
	production: '155ee5f9-6571-4aed-bb02-3c3c9580b7cd',
};

export const getMatchTheMarketUUIDForEnv = () => {
	return (
		MATCH_THE_MARKET_TICKER_UUID[window.Stash.env] || MATCH_THE_MARKET_TICKER_UUID.edge
	);
};
